// extracted by mini-css-extract-plugin
export default {"highlights":"styles_highlights__uRDtf","title":"styles_title__tkor1","disclaimer":"styles_disclaimer__++Uxa","content":"styles_content__SvulZ"};